<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">

          <div class="modal-header">
            <slot name="header">
              Title Goes Here
            </slot>
          </div>

          <div class="modal-body">
            <slot name="body">
              Insert Text Here
            </slot>
          </div>

          <div class="modal-footer">
              <button class="modal-default-button" @click="$emit('close')">
                Cool
              </button>
          </div>

        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  export default {
    props: ['show'],
    data: function () {
    	return {
        comment: ''
      };
    },
    methods: {
      close: function () {
        this.show = false;
      }
    }
  };
</script>

<style>

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 600px;
  margin: 0px auto;
  padding: 20px 50px;
  background-color: #272727;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
  font-size: 1rem;
}

.modal-body {
  margin: 20px 0;
  text-transform: none;
  font-family: 'Open Sans';
  font-size: 0.8rem;
  letter-spacing: normal;
}

.modal-default-button {
  border-radius: 0;
  width: 60px;
  padding: 5px;
  text-transform: uppercase;
  font-family: Raleway;
  font-weight: bold;
  letter-spacing: 1px;
  color: #272727;
  background: #e26839;
  border: none;
  box-shadow: none;
  cursor: pointer;
}

.modal-default-button:hover {
  background: #42b983;
}

a {
  color: #42b983;
}
a:hover {
  text-decoration: none;
}

.modal-footer {
  display: flex;
  justify-content: center;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.2);
  transform: scale(1.2);
}

@media(max-width: 980px) {
  .modal-header h3 {
    font-size: 3rem;
  }

  .modal-body {
    margin: 40px 0;
    font-size: 2.5rem;
    letter-spacing: normal;
  }

  .modal-default-button {
    width: 200px;
    padding: 25px;
    color: #272727;
    font-size: 2rem;
  }
}

</style>



// WEBPACK FOOTER //
// modal.vue?3e930d66